import * as Linking from 'expo-linking';

export default {
  prefixes: [
    Linking.makeUrl('/'),
    'http://app.suplias.com',
    'https://app.suplias.com',
    'http://buy.suplias.com',
    'https://buy.suplias.com',
    'http://suplias.shop',
    'https://suplias.shop',
    'suplias://supliasbuyer'
  ],
  config: {
    screens: {
      Root: {
        screens: {
          Home: {
            path: '/',
            screens: {
              HomeTab: {
                path: '/',
                screens: {
                  Category: {
                    path: '/category'
                  },
                  Manufacturer: {
                    path: '/manufacturer'
                  }
                }
              },
              ManufacturerBrand: {
                path: '/manufacturer/:id'
              },
              ManufacturerProduct: {
                path: '/manufacturer/:id/product'
              },
              Brand: {
                path: '/brand'
              },
              BrandProduct: {
                path: '/brand/:id'
              },
              CategoryProduct: {
                path: '/category/:id'
              },
              SearchProduct: {
                path: '/search?q=xyz'
              },
              Product: {
                path: '/product'
              }
            }
          },
          Settings: {
            path: 'setting',
            screens: {
              Settings: {
                path: '/'
              },
              Profile: {
                path: 'profile'
              },
              Password: {
                path: 'update-password'
              },
              Voucher: {
                path: 'voucher'
              }
            }
          },
          // Product: {
          //   path: 'product'
          // },
          ProductExplore: {
            path: 'explore/:prev_route/:query'
          },
          Cart: {
            path: 'cart'
          },
          Feedback: {
            path: 'feedback'
          },
          // Feed: {
          //   path: 'feed'
          // },
          // CallRep: {
          //   path: 'call-rep'
          // },
          Order: {
            path: 'order',
            screens: {
              OrderList: {
                // path: 'list',
                screens: {
                  All: {
                    path: 'all'
                  },
                  Pending: {
                    path: 'pending'
                  }
                }
              },
              OrderSingle: {
                path: 'view/:order_id'
              },
              OrderInvoice: {
                path: 'invoice/:order_id'
              },
            }
          },
          // Notification: {
          //   path: 'notification'
          // },
          Balance: {
            path: 'balance'
          },
          PaystackCheckout: {
            path: 'paystack-checkout'
          },
          Chat: {
            path: 'chat'
          },
          History: {
            path: 'history'
          },
        },
      },
      Intro: {
        screens: {
          Auth: {
            path: 'auth'
          },
          Onboard: {
            path: 'onboard'
          }
        }
      },
      About: {
        path: 'about'
      },
      NotFound: '*',
    },
  },
};
